import HospitalContactRecordForm from '../../../components/forms/Hospital/HospitalContactRecordForm';
import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import { connect } from 'react-redux';
import { contactRecordTypeListFetch } from '../../../lib/redux/actions/contactRecordType';

const mapStateToProps = (state) => ({
  ...state.contactRecordTypes,
});

const mapDispatchToProps = {
  contactRecordTypeListFetch,
};

const HospitalContactRecordDrawer = ({
  hospital,
  canRemove = false,
  onRemove,
  toggleFormUnderEdit,
  //  contactRecordTypes = [],
  contact,
  onSubmit,
  startOpen = false,
  isNew = false,
  contactRecordTypeListFetch,
  //  onDiscardChanges,
}) => {
  const [open, setOpen] = useState(startOpen);

  useEffect(() => {
    if (contactRecordTypeListFetch) {
      contactRecordTypeListFetch();
    }
  }, [contactRecordTypeListFetch]);

  // Find hospital contact record type
  //  const hospitalRecordType = contactRecordTypes.find((o) => o?.code === ContactRecordTypeCodes.Hospital);
  //  const recordType = hospitalRecordType || { name: 'Hospital', code: ContactRecordTypeCodes.Hospital };

  const canClose = !isNew; // Hospital contacts can always be closed when not new

  const handleHeaderClick = () => {
    if (canClose) {
      setOpen(!open);
    }
  };

  const handleFormSubmit = (c) => {
    const result = onSubmit(c);
    if (canClose) {
      setOpen(false);
    }
    return result;
  };

  return (
    <Card className={'mb-2 no-shadow card-tight'}>
      <Card.Header className={` ${canClose ? 'pointer' : ''}`} onClick={handleHeaderClick} title={canClose ? 'Click to edit' : ''}>
        <span className={'h6'}>{!isNew ? contact.name : 'New Hospital Contact'}</span>
        {/*<span className={`ml-4 badge badge-pill badge-info`}>{recordType?.name ?? 'Hospital'}</span>*/}
        <>
          <span className={'float-right mt-2 h6'}>
            Notifications{' '}
            {contact.notifyByEmail || contact.notifyByMobile ? (
              <i className={'fas fa-check-circle text-primary'} />
            ) : (
              <i className={'fas fa-times-circle text-danger'} />
            )}
          </span>
          {contact.email && (
            <span className={'ml-4 h6'}>
              <i className={`fas fa-envelope mr-2 ${contact.notifyByEmail ? 'text-primary' : 'text-danger'}`} />
              {contact.email}
            </span>
          )}

          {contact.mobileNumber && (
            <span className={'ml-4 h6'}>
              <i className={`fas fa-phone mr-2`} />
              {contact.mobileNumber}
            </span>
          )}

          {/* Show hospital-specific flags */}
          {contact.isInitialInvoice && <span className={'ml-2 badge badge-info'}>Initial Invoice</span>}
          {contact.isChaseToContact && <span className={'ml-2 badge badge-info'}>Chase To Contact</span>}
          {contact.isDisabled && <span className={'ml-2 badge badge-secondary'}>Disabled</span>}
        </>
      </Card.Header>
      {open && (
        <Card.Body>
          <div className={'col pl-0'}>
            <HospitalContactRecordForm
              hospital={hospital}
              toggleFormUnderEdit={toggleFormUnderEdit}
              form={'HospitalContactRecordForm' + contact.name + (contact.id ?? '-1')}
              key={contact.name}
              contact={contact}
              onClose={() => canClose && setOpen(false)}
              isNew={isNew}
              onSubmit={handleFormSubmit}
            />
          </div>
          {canRemove && onRemove && (
            <button className={'btn btn-danger float-right btn-sm'} type={'button'} onClick={() => onRemove(contact)}>
              Remove Contact
            </button>
          )}
        </Card.Body>
      )}
    </Card>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(HospitalContactRecordDrawer);
